import { DocumentPage } from "../components";
import {
  getSubscriptionAgreementData,
  SubscriptionAgreementPage,
} from "../lib/api";
import { getGlobalStaticProps } from "../lib/helpers";

interface SubscriptionAgreementData {
  page: SubscriptionAgreementPage;
}

export default function SubscriptionAgreement({
  data,
}: {
  data: SubscriptionAgreementData;
}) {
  const { title, date, contentMdx } = data.page;
  return <DocumentPage title={title} date={date} contentMdx={contentMdx} />;
}

export async function getStaticProps() {
  const page = await getSubscriptionAgreementData();
  const data: SubscriptionAgreementData = {
    page,
  };
  const props = await getGlobalStaticProps(
    { data },
    {
      pageTitle: page.title,
      pageDescription: page.meta_description,
      publishDate: page.date,
      pageImage: page.image,
    }
  );
  return { props };
}
